<template>
  <div class="loading">
    <div class="loading-gif" v-if="type===1"></div>
    <div class="loading-gif2" v-else-if="type===2"></div>
    <!-- <van-loading v-else-if="type===2" class="loading-vant" type="spinner" color="#599d00" size="80"></van-loading> -->
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    type: {
      type: Number,
      default: 1
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color: rgba(0,0,0,0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-gif {
    width: 100%;
    height: 100%;
    background: #fff url(../assets/loading.gif) no-repeat center;
  }
  .loading-gif2 {
    width: 250px;
    height: 200px;
    background: #fff url(../assets/loading.gif) no-repeat center;
    border-radius: 10px;
  }

}

</style>